import React, {
  useRef,
  useContext,
}                             from 'react';
import { useTranslation}      from 'react-i18next';
import PackageBillingContext  from './context';
import ReceiptIcon            from '@material-ui/icons/Receipt';
import List                   from '~/containers/List';
import { showPackageBilling } from '~/config/routes';
import packageBillingColumns  from '~/config/customQuery/packageBillingConfig';
import Request                from '~/providers/Request';
import csvGenerator           from '~/utils/csvGenerator';
import { toast }              from 'react-toastify';
import moment                 from 'moment';
import dig                    from 'object-dig';
import { AbilityContext }     from '~/contexts/Can';

function PackageBillingsList() {
  const { t } = useTranslation();
  const listEl = useRef(null);
  const ability = useContext(AbilityContext);

  function generateCSV() {
    toast.info('Arquivo CSV esta sendo gerado!');

    const params = function() {
      const vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
          vars[key] = value;
      });

      return vars;
    };

    Request.get('/admin/package_billings/', { ...params(), csv: true })
      .then(response => {
        const dateFormat = date => date && moment(date).format('DD/MM/YYYY HH:mm:ss');
        const headers = ['ID', 'Data', 'Usuário', 'Tipo', 'Licenças', 'Status', 'Parceiro'];
        const rows = response.data.map(pack_bill => {
          const transactionAt = dateFormat(pack_bill.transaction_at);

          return [
            pack_bill.id, transactionAt, pack_bill.user_name, pack_bill.pack_type,
            pack_bill.pack_size, pack_bill.partner_status, dig(pack_bill.partner, 'name')
          ];
        });

        csvGenerator('compras-de-adicionais.csv', [headers, ...rows]);

        toast.success('Arquivo CSV gerado com sucesso!');
      })
      .catch(err => {
        toast.error('Não foi possível gerar o arquivo CSV');
        console.error('[ERROR to generateCSV]', err);
      });
  }

  const actions = [
    'search',
    'filter',
    'export',
  ];

  if(ability.can('show', 'PackageBillings')) {
    actions.push('show');
  }

  return (
    <>
      <List
        routeToShow={showPackageBilling}
        listEl={listEl}
        path={'/admin/package_billings/'}
        actions={actions}
        onExport={generateCSV}
        paperProps={{
          Icon:ReceiptIcon,
          iconColor:'green',
          title: t('packageBilling.defPlural'),
        }}
        columns={packageBillingColumns()}
        context={PackageBillingContext}
        recordMap={
          record => ({
            ...record,
            transaction_at: record.transaction_at ? moment(record.transaction_at).format('DD/MM/YYYY HH:mm') : null,
            expires_at: record.expires_at ? moment(record.expires_at).format('DD/MM/YYYY HH:mm') : null,
            partner: record.partner ? record.partner.name : ''
          })
        }
      />
    </>
  );
}

export default React.memo(PackageBillingsList);
